// Alphabetical order please!

export { default as citations } from './citations';
export { default as config } from './config';
export { default as authors } from './authors';
export { default as documentIndex } from './document-index';
export { default as recommendations } from './recommendations';
export { default as stats } from './stats';
export { default as types } from './types';
export { default as entitlements } from './entitlements';
export { default as documents } from './documents';
export { default as following } from './following';
export { default as library } from './library';
export { default as location } from './location';
export { default as pendingActions } from './pending-actions';
export { default as profiles } from './profiles';
export { default as searchBar } from './search-bar';
export { default as searchResults } from './search-results';
export { default as session } from './session';
export { default as urlResolvers } from './url-resolvers';
export { default as viewport } from './viewport';



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/index.js